module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/04e830c035b8a5b18064e65bc8603e67.png";